// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { getFormSubmitErrors } from 'gandi.react-form';
import { compose } from 'redux';

import { selectFromConfig } from '@gandi/redux-config';
import { withTranslator } from '@gandi/translate';

import { withRouter } from 'src/helpers/withRouter';
import type { FullState } from 'src/types';

import AbuseForm, {
  type OwnProps,
  type Props,
  type InjectedProps,
  type StateProps,
} from './components/AbuseForm';

export { default as AbuseFormValidation } from './components/AbuseFormValidation';

const selectDisabledTips: FullState => Array<string> = selectFromConfig(
  'app.disabledTips',
  []
);
const selectDisabledWarnings: FullState => Array<string> = selectFromConfig(
  'app.disabledWarnings',
  []
);

const mapStateToProps = (state: FullState): StateProps => ({
  disabledTips: selectDisabledTips(state),
  disabledWarnings: selectDisabledWarnings(state),
  submitErrors: getFormSubmitErrors('AbuseForm')(state),
});

// $FlowFixMe[incompatible-call]
const connector = connect<
  Props,
  {| ...OwnProps, ...InjectedProps |},
  StateProps,
  {||},
  FullState
>(mapStateToProps);

export default (compose(
  // $FlowFixMe[underconstrained-implicit-instantiation]
  withRouter,
  withTranslator({ propsNamespace: 'translator' }),
  connector
)(AbuseForm): React.ComponentType<OwnProps>);
